import { Observable, } from "rxjs";
import { filter } from "rxjs/operators";
import { ARCParsedData, ARCSolutions, ProcessLine } from "../../types";
import { getARCDataObservable } from "./ARCModel";


const shareSolutionData = (solution: ARCSolutions, line: ProcessLine) => getARCDataObservable().pipe(
    filter(data => data.solution === solution && data.line === line),
);

export const getARCSolutionData = (solution: ARCSolutions, line: ProcessLine = ProcessLine.NO_LINE): Observable<ARCParsedData> =>
    shareSolutionData(solution, line)